import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Hice mi primera venta al tercer día. Cuatro gelatinas para un cumpleaños. Mis clientas no podían creer que yo las había hecho. El método es clarísimo y los diseños son espectaculares.',
    initials: 'VR',
    name: 'Valentina R.',
    loc: 'Buenos Aires · Principiante absoluta',
    gradient: 'from-pink to-[#8b5cf6]'
  }, {
    quote: 'Intenté con YouTube, con otros cursos, y siempre me faltaba la parte de cómo vender. Acá está todo. La Calculadora de Precios y el curso de Instagram solos ya valieron el dinero.',
    initials: 'CF',
    name: 'Camila F.',
    loc: 'Rosario · Ya tenía experiencia en cocina',
    gradient: 'from-pink to-gold'
  }, {
    quote: 'En el primer fin de semana vendí suficiente para recuperar todo lo que pagué. Ahora tengo lista de espera. No me alcanza el tiempo para todos los pedidos y eso es el mejor problema posible.',
    initials: 'LM',
    name: 'Lucía M.',
    loc: 'Córdoba · 2 semanas usando el método',
    gradient: 'from-[#8b5cf6] to-pink'
  }];
  return <section className="bg-bg2 py-16 px-5" data-id="element-136">
      <div className="container-custom" data-id="element-137">
        <span className="section-tag" data-id="element-138">Resultados reales</span>
        <h2 className="section-title" data-id="element-139">
          ELLAS YA ESTÁN
          <br data-id="element-140" />
          GENERANDO INGRESOS
        </h2>
        <p className="section-sub mb-9" data-id="element-141">
          No te pido que me creas a mí. Estas son sus palabras.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-142">
          {testimonials.map((testi, idx) => <div key={idx} className="bg-card border border-border rounded-xl p-7 relative" data-id="element-143">
              <div className="absolute -top-2 left-5 font-serif text-[80px] text-pink leading-none opacity-40" data-id="element-144">
                "
              </div>

              <div className="text-gold text-[14px] mb-3 tracking-[2px]" data-id="element-145">
                ★★★★★
              </div>
              <p className="text-[15px] text-text leading-[1.6] mb-4.5 italic pt-3.5" data-id="element-146">
                {testi.quote}
              </p>

              <div className="flex items-center gap-3 border-t border-border pt-4 mt-4" data-id="element-147">
                <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${testi.gradient} flex items-center justify-center font-bold text-[15px] text-white shrink-0`} data-id="element-148">
                  {testi.initials}
                </div>
                <div data-id="element-149">
                  <div className="text-[14px] font-bold text-white" data-id="element-150">
                    {testi.name}
                  </div>
                  <div className="text-[12px] text-muted" data-id="element-151">{testi.loc}</div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}